import { render, staticRenderFns } from "./MedicalDeviceLicence.vue?vue&type=template&id=2d3e373e&scoped=true"
import script from "./MedicalDeviceLicence.vue?vue&type=script&lang=js"
export * from "./MedicalDeviceLicence.vue?vue&type=script&lang=js"
import style0 from "./MedicalDeviceLicence.vue?vue&type=style&index=0&id=2d3e373e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3e373e",
  null
  
)

export default component.exports